import React from 'react';

const TOP_VERIFIED_TIER = 'top_verified';
const VERIFIED_TIER = 'verified';
const ACTIVE_TIER = 'active';

export default function SupplierBadge({ tier }) {
  let tierClass;
  let tierIcon;
  let tierLabel;

  switch (tier) {
    case TOP_VERIFIED_TIER:
      tierClass = 'supplierBadge-topFactory';
      tierIcon = 'ph-bold ph-sketch-logo';
      tierLabel = 'Nearshore Vetted';
      break;
    case VERIFIED_TIER:
      tierClass = 'supplierBadge-verified';
      tierIcon = 'ph-fill ph-seal-check';
      tierLabel = 'Verified Factory';
      break;
    case ACTIVE_TIER:
      tierClass = 'supplierBadge-basic';
      tierLabel = 'Active Factory';
      break;
    default:
      tierClass = 'supplierBadge-blank';
      tierLabel = '';
      break;
  }

  return (
    <div className="badges py-1">
      <span className={`supplierBadge ${tierClass}`}>
        {tierIcon && <i className={tierIcon}></i>} {tierLabel}
      </span>
    </div>
  );
}
